{
    "Title": "Détails de l'activité ACD",
    "SectionTitleDatetimevalues": "VALEURS DE DATE\/HEURE",
    "SectionTitleDeviceandacdinfo": "INFORMATION SUR L'APPAREIL ET L'ACD",
    "SectionTitleStatusvalues": "VALEURS D'ÉTAT",
    "SectionTitleAssociatedtelephonyenv": "ENVIRONNEMENT TÉLÉPHONIQUE ASSOCIÉ",
    "SectionTitleDiagnosticvalues": "VALEURS DIAGNOSTIQUES",
    "ButtonHelp": "Aide",
    "ButtonClose": "Fermer",
    "ColumnHeaderValue": "Valeur",
    "ColumnHeaderFieldStatistic": "Champ \/ Statistique",
    "ButtonCollapseall": "Réduire tout",
    "NAME": "ACDDNDActivity"
}